import { render } from "./DynamicDataTable.vue?vue&type=template&id=baa49bc6&ts=true"
import script from "./DynamicDataTable.vue?vue&type=script&lang=ts"
export * from "./DynamicDataTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicDataTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "baa49bc6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('baa49bc6', __exports__)) {
    api.reload('baa49bc6', __exports__)
  }
  
  module.hot.accept("./DynamicDataTable.vue?vue&type=template&id=baa49bc6&ts=true", () => {
    api.rerender('baa49bc6', render)
  })

}


export default __exports__